import React from 'react';
import { Card, Box, Typography, Divider, Grid } from '@mui/material';

export default function DeviceHealth({ totalDevices = 2, online = 1, offline = 1 }) {
  return (
    <>
      <Box
        sx={{
          display: 'inline-block',
          px: 2.5,
          py: 1,
          borderRadius: 1,
          mb: 1,
          backgroundColor: '#F6F9FF',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: '14px', lineHeight: '14px' }}>
          Device Health
        </Typography>
      </Box>
      <Typography sx={{ fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat' }}>{totalDevices}</Typography>
      <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Total Devices</Typography>
      <Divider sx={{ my: 1.5, mx: 2 }} />
      <Grid container>
        <Grid size={{ xs: 6 }}>
          <Typography sx={{ color: '#70C300', fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat' }}>
            {online}
          </Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Online</Typography>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Typography sx={{ color: '#C1C1C1', fontSize: '25px', fontWeight: 700, fontFamily: 'Montserrat' }}>
            {offline}
          </Typography>
          <Typography sx={{ fontSize: '14px', fontWeight: 700 }}>Offline</Typography>
        </Grid>
      </Grid>
    </>
  );
}
